<div class="experience-list-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="toggleSidenav()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <h2>{{ 'ENGAGE.EXPERIENCE.TITLE.PLURAL' | translate }}</h2>
        </div>
    </mat-toolbar>
    <div class="experience-list">
        <div class="shimmer-container min-w-full" *ngIf="isLoadingExperiences; else showExperiences">
            <div class="shimmer">
                <div class="shimmer-card table animate"></div>
            </div>
        </div>

        <ng-template #showExperiences>
            <div *ngIf="experiences.length === 0; else experiencesList">
                <div class="button-container pt-48" fxLayout="column" fxLayoutAlign="center center">
                    <button class="add-new experience" mat-fab>
                        <span>{{ 'ENGAGE.EXPERIENCE.MESSAGES.NO_EXPERIENCES' | translate }}</span>
                    </button>
                </div>
            </div>
            <ng-template #experiencesList>
                <mat-card appearance="outlined" class="experience-card p-0 mb-12 mat-elevation-z0" *ngFor="let experience of experiences" routerLink="{{ experience.id }}">
                    <mat-card-header class="experience-card-header" [class.no-image]="!(experience.headerBanner && experience.headerBanner.image)">
                        <div
                            *ngIf="experience.headerBanner && experience.headerBanner.image"
                            mat-card-avatar
                            class="experience-card-image"
                            [style.background-image]="'url(' + experience.headerBanner.image.url + ')'"
                        ></div>
                        <mat-card-title>{{ experience.name }}</mat-card-title>
                        <!-- <mat-card-subtitle>Last updated: {{ experience.updated }}</mat-card-subtitle> -->
                    </mat-card-header>
                    <mat-card-content>
                        <span> {{ experience.memberCount ?? 0 }} {{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }} </span>
                        <span> {{ experience.widgetCount ?? 0 }} {{ 'ENGAGE.WIDGET.TITLE.PLURAL' | translate }} </span>
                    </mat-card-content>
                    <mat-card-actions>
                        <app-white-button [label]="'GENERAL.BUTTON.PREVIEW'" (onClick)="onPreviewHomeScreen(experience.id)"></app-white-button>
                    </mat-card-actions>
                </mat-card>
            </ng-template>
        </ng-template>
    </div>
</div>
